/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BarterResult } from './barterResult.model';
import { BarterState } from './barterState.model';
import { SubjectContactResponseDto } from './subjectContactResponseDto.model';
import { BarterReceivedParcelGeometryDto } from './barterReceivedParcelGeometryDto.model';
import { MonthYearUnit } from './monthYearUnit.model';
import { BarterNumberFormat } from './barterNumberFormat.model';
import { BarterPassedParcelGeometryDto } from './barterPassedParcelGeometryDto.model';
import { VersionType } from './versionType.model';


export interface BarterResponseDto { 
    anyPassedGeometryOutOfDate?: boolean;
    anyPassedParcel?: boolean;
    anyReceivedGeometryOutOfDate?: boolean;
    anyReceivedParcel?: boolean;
    appendixNumber?: number;
    barterNumber?: number;
    barterNumberFormat?: BarterNumberFormat;
    barterNumberOfficial?: string;
    barterYear?: number;
    concernedSubject?: SubjectContactResponseDto;
    counterparty?: SubjectContactResponseDto;
    durationMonths?: number;
    durationMonthsUnit?: MonthYearUnit;
    durationToDate?: string;
    efficiencyFromDate?: string;
    endDate?: string;
    endType?: string;
    expirationDate?: string;
    furtherRentPossible?: boolean;
    groupId?: number;
    id?: number;
    incomingAmount?: number;
    incomingPayoutDate?: string;
    indefinite?: boolean;
    invalid?: boolean;
    invalidExplanation?: string;
    note?: string;
    noticePeriodMonths?: number;
    noticePeriodMonthsUnit?: string;
    outgoingAmount?: number;
    outgoingPayoutDate?: string;
    passedParcelGeometries?: Array<BarterPassedParcelGeometryDto>;
    paymentsFromEconomicYear?: boolean;
    previousVersionId?: number;
    receivedParcelGeometries?: Array<BarterReceivedParcelGeometryDto>;
    resignDate?: string;
    results?: Array<BarterResult>;
    reusedPreviousExpiration?: boolean;
    state?: BarterState;
    stateName?: string;
    sumConcernedAcreage?: number;
    toEconomicYear: boolean;
    versionType?: VersionType;
}
export namespace BarterResponseDto {
}


